// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wq_a bik_b"};